module.exports = __webpack_public_path__ + "static/image25@2x-739e4e90cc7f239b1e399c5c24de4134.png";